// extracted by mini-css-extract-plugin
module.exports = {"wtitle":"diav_wtitle__1XdRZ"};